import { md5 } from "tiny-hashes";

const createProductsHash = (products) =>
  md5(products.reduce((s, { id }) => s + id, ""));

export default createProductsHash;
